import {
  GET_MAP_OVERLAY_REQUEST,
  GET_MAP_OVERLAY_SUCCESS,
  GET_MAP_OVERLAY_FAILURE,
} from '../constants/actionTypes'

const initialState = {
  errorMessage: '',
  /*
	Okay so these overlay dicts store multiple overlays as values. the keys are fips codes, so for countyOverlay we just use the state fips and for zipOverlay we use the full 5 digit code.
	*/
  countyOverlay: {},
  zipOverlay: {},
  isFetchingOverlay: false,
}

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_MAP_OVERLAY_REQUEST:
      return {
        ...state,
        isFetchingOverlay: action.isFetchingOverlay,
      }
    case GET_MAP_OVERLAY_SUCCESS:
      const update = {
        isFetchingOverlay: action.isFetchingOverlay,
      }
      if (action.overlayType === 'county') {
        update.countyOverlay = {
          ...state.countyOverlay,
          [action.fipsQuery]: action.overlay,
        }
      } else if (action.overlayType === 'zip') {
        update.zipOverlay = {
          ...state.zipOverlay,
          [action.fipsQuery]: action.overlay,
        }
      }
      return {
        ...state,
        ...update,
      }
    case GET_MAP_OVERLAY_FAILURE:
      return {
        ...state,
        isFetchingOverlay: action.isFetchingOverlay,
        errorMessage: action.message,
      }
    default:
      return state
  }
}
